import axios from "axios";
import apis from "./index";

// get ip address log activity 3rd party api
// https://ipv4.jsonip.com/
export const systemIpAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json")
      return response
    }
    catch (error) {
      throw error
    }
  }
  
  // pass ip address log activity 3rd party api
  
  export const pass_systemIpAddress = async (ip) => {
    try {
      const response = await axios.get(`http://ip-api.com/json/${ip}`)
      return response
    }
    catch (error) {
      throw error
    }
  }

  export const CreatelogActivityApi= async (val) => {
    try {
      const response = await axios.post(`${apis?.logActivity?.createLogActivity}`,val, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
  